import * as React from 'react';
var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const SvgIcCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#383538",
  fillRule: "evenodd",
  d: "M2.957 2.957c.26-.26.683-.26.943 0l4.035 4.035 4.036-4.035a.667.667 0 1 1 .943.943L8.878 7.935l4.036 4.036a.667.667 0 1 1-.943.943L7.935 8.878 3.9 12.914a.667.667 0 1 1-.943-.943l4.036-4.036L2.957 3.9a.667.667 0 0 1 0-.943",
  clipRule: "evenodd"
})));
export { SvgIcCancel as ReactComponent };